//#region src/modules/file-uploader/types/file-uploader-item-type.ts
var e = /* @__PURE__ */ function(e) {
	return e.Waiting = "Waiting", e.Uploading = "Uploading", e.Uploaded = "Uploaded", e.Deleting = "Deleting", e;
}({});
//#endregion
export { e as FileUploaderItemStateEnum };
